import { BaseApiClient } from "../utils";
import { Auth } from "./models";

export default class Client extends BaseApiClient {
  public async login(username: string): Promise<Auth> {
    return this.fetch('POST', '/api/v1/login', {
      username: username
    });
  }
}